module.exports = __webpack_public_path__ + "img/bg_recom_sch.da270e46.png";